import $ from 'jquery';

export const MOBILE_WIDTH = 768;
export const TABLET_WIDTH = 992;

const windowWidth = $(window).width();
export const isMobile = windowWidth < MOBILE_WIDTH;
export const isTablet = windowWidth < TABLET_WIDTH;

export const dateFormat = (date) => {
  return `${date[0]} ${date[1].substring(0, 3)} ${date[2]}`;
}


/** WEBPACK FOOTER **
 ** ./assets/js/common/constants.js
 **/